import React from "react";
import {useSelector} from "react-redux/es/exports";
import Sidebar from "./components/Sidebar";
import {Routes, Route} from "react-router-dom";
import Login from "./pages/Login";
import ErrorPage from "./components/ErrorPage";
import ForgotPassword from "./layout/forgotPassword/ForgotPassword";
import ResetPassword from "./layout/forgotPassword/ResetPassword";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./App.css"

function App() {
    const userAndToken = useSelector((state) => state.user);
    if (userAndToken.token) {
        return (
            <>
                <ToastContainer />
                <Routes>
                    <Route path="/*" element={<Sidebar/>}/>
                    <Route path="/error" element={<ErrorPage/>}/>
                </Routes>

            </>
        );
    } else {
        return (
            <>
                <Routes>
                    <Route path="/" element={<Login/>}/>
                    <Route path="/forgot/password/page" element={<ForgotPassword/>}/>
                    <Route path="/reset/password/page" element={<ResetPassword/>}/>
                    <Route path="/error" element={<ErrorPage/>}/>
                </Routes>
            </>
        );
    }
}

export default App;
